import type { HTMLProps } from 'react';
import { clsx } from 'clsx';
import styles from './input-hint.module.scss';

interface InputHintProps extends HTMLProps<HTMLDivElement> {
  id: string;
}

export function InputHint({ className, children, ...rest }: InputHintProps) {
  return (
    <div className={clsx(styles.inputHint, className)} {...rest}>
      {children}
    </div>
  );
}
